<template>
  <!--header-->


  <div class="underTheDesignedHomePage">
    <div class="header_bootom">

      <div class="header_content">
        <div class="header_title">
          专业群类目
        </div>
        <div class="header_ul">
          <ul>
            <li> <router-link to="/liaoningTraffic">  <img src="../assets/image/jiaozhuanicon_03.jpg" alt=""></router-link></li>
            <li> <img src="../assets/image/jiaozhuanicon_05.jpg" alt=""></li>
            <li> <img src="../assets/image/jiaozhuanicon_07.jpg" alt=""></li>
            <li> <img src="../assets/image/jiaozhuanicon_09.png" alt=""></li>
            <li> <img src="../assets/image/jiaozhuanicon_15.jpg" alt=""></li>
            <li> <img src="../assets/image/jiaozhuanicon_16.jpg" alt=""></li>
            <li> <img src="../assets/image/jiaozhuanicon_17.jpg" alt=""></li>
          </ul>
        </div>
      </div>
    </div>


  </div>



  <!--头部结束-->
</template>

<script>
import { ref, reactive } from "vue";
import router from "@/router";
import { useRouter } from "vue-router";
export default {
  setup() {
    const router = useRouter();
    const userName = localStorage.getItem("userName");


    const theColumnList = ref([
      {
        title: "首页",
        url: "/",
      },
      {
        title: "实验项目",
        url: "/theListOf",
      },
      {
        title: "最新资讯",
        url: "/newlist",
      },
      {
        title: "共享排行",
        url: "/shareRanking",
      },
    ]);
    const currentIndex = ref(parseInt(localStorage.getItem("tABWhich")));
    const columnClick = (index) => {
      localStorage.setItem("tABWhich", index);
      currentIndex.value = parseInt(localStorage.getItem("tABWhich"));
      console.log(666, index)
      console.log(777, parseInt(currentIndex.value))
    };

    //退出登陆
    const loggedOut = () => {
      localStorage.removeItem("userName");
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
      localStorage.removeItem("whetherTheLogin");
      router.push("/");
      setTimeout(function () {
        location.reload();
      }, 500);
    };

    //点击搜索
    const searchData = reactive({
      searchContent: null,

    });
    const atTheTopOfTheSearch = (value) => {
      localStorage.setItem("tABWhich", 1);
      localStorage.setItem("searchContent", value);
      searchData.searchContent = value;

      router.push({
        path: "/theListOf",
        query: { theSearchCriteria: value },
      });
      setTimeout(function () {
        location.reload();
      }, 50);
    };
    return {
      searchData,
      atTheTopOfTheSearch,
      theColumnList,
      currentIndex,
      columnClick,
      userName,
      loggedOut,
    };
  },

  name: "headerTop",
};
</script>

<style scoped>
.underTheDesignedHomePage {
  margin-top: 20px;
  margin-bottom: 50px;
}

.header_right a {
  color: #a50c0d;
}

.header_search {
  width: 360px;
  height: 40px;
  float: left;
  border: 2px solid #a50c0d;
  margin-top: 51px;
  margin-left: 94px;
  background: #fff;
}

.header {
  height: 680px;
  background: url(../assets/image/jiaozhuanbg_01.jpg);
}

.loginOut {
  color: #a50c0d;
  margin-left: 8px;
  cursor: pointer;
}

.header_top {
  height: 150px;
  background-image: linear-gradient(to bottom, rgb(255, 255, 255), #fff0);
}

.header_bootom {
  width: 1116px;
  margin: 0 auto;
  background: #FFF;
  border-radius: 20px;
  padding: 23px 50px 23px 50px;
  height: 434px;
}

.header_title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}

.header_ul ul li {
  float: left;
  margin-right: 20px;
  margin-bottom: 15px;
}
</style>